import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseURL } from "../../BaseUrl";
import Swal from "sweetalert2";
// Function to retrieve token from localStorage
const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllmachinedata = createAsyncThunk(
    "machine/getAllmachinedata",
    async () => {
      try {
        const response = await baseURL.get(`/machine/`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const createmachinedata = createAsyncThunk(
    "machine/createmachinedata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.post(`/machine/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const getSinglemachinedata = createAsyncThunk(
    "machine/getSinglemachinedata",
    async (id) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.get(`/machine/${id}`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const updatemachinedata = createAsyncThunk(
    "machine/updatemachinedata",
    async (data) => {
      try {
        // console.log("authtnk", getAuthHeaders())
        const response = await baseURL.patch(`/machine/`,data,getAuthHeaders()
        );
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  export const getMachineList = createAsyncThunk(
    "machine/getMachineList",
    async (id) => {
      try {
        const response = await baseURL.get(`/machine/machinelist/${id}`,getAuthHeaders());
        // console.log("response.data", response.data);
        return response.data.data;
      } catch (error) {
        // alert(`${error.response.data.message}`)
        throw error; // Ensure the error is propagated
      }
    }
  );
  //delete 
export const deleteMachineData = createAsyncThunk(
  "machine/deleteMachineData",
  async (id) => {
    // console.log("cid===>",cid)
    try {
      const response = await baseURL.delete(`/machine/delete-machine/${id}`,getAuthHeaders());
      // console.log("response.data", response.data)
      return response.data.data;
    } catch (error) {
      // alert(`${error.response.data.message}`)
      Swal.fire({
        icon: "error",
        title: `${error.response.data.message}`,
      });
      // throw error; // Ensure the error is propagated
    }
  }
);
export const machineQRCodeDownload = createAsyncThunk(
  "qr/machineQRCodeDownload",
  async (data) => {
    try {
      const response = await baseURL.post(`/machine-qr-code`, data);
      // console.log("response", response);
      return response.data;
    } catch (error) {
      // console.log(error);
      return error.response.data;
    }
  }
);
  export const machineSlice = createSlice({
    name: "machine",
    initialState: {
      machineData: [],
      singleMachineData:{},
      machineList:[],
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(getAllmachinedata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getAllmachinedata.fulfilled, (state, action) => {
          state.loading = false;
          state.machineData = action.payload;
        })
        .addCase(getAllmachinedata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getSinglemachinedata.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSinglemachinedata.fulfilled, (state, action) => {
          state.loading = false;
          state.singleMachineData = action.payload;
        })
        .addCase(getSinglemachinedata.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
        builder
        .addCase(getMachineList.pending, (state) => {
          state.loading = true;
        })
        .addCase(getMachineList.fulfilled, (state, action) => {
          state.loading = false;
          state.machineList = action.payload;
        })
        .addCase(getMachineList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error;
        });
    },
  });
  
  // SELECTORS
  export const getMachineData = (state) => state.machine.machineData;
  export const getUniqueMachineData = (state) => state.machine.singleMachineData;
  export const getAllmachinelist = (state) => state.machine.machineList;
    export const machineError = (state) => state.department.loading;
  
  // EXPORTS
  export default machineSlice.reducer;
  